import React, { cloneElement } from 'react';
import Drawer from '@ocp/drawer';
import Icon, { IconSymbol } from '@ocp/icon';
import { useDrawerListReducer } from '../../hooks/index';
import styles from './DrawerList.module.scss';
export const DrawerListItem = ({ hasSecondary = false, children = undefined, onTouch = undefined, }) => (React.createElement("span", { className: styles.item, onTouchEnd: (e) => {
        if (onTouch) {
            onTouch();
        }
        e.preventDefault();
    } },
    React.createElement("span", { className: styles.itemBody }, children),
    hasSecondary && (React.createElement("span", { className: styles.itemIcon },
        React.createElement(Icon, { symbol: IconSymbol.ArrowNext })))));
const DrawerList = ({ items, trigger }) => {
    const [state, dispatch] = useDrawerListReducer();
    const handleOpenMain = () => dispatch({ type: 'open_main' });
    const handleOpenSecondary = (data) => dispatch({ type: 'open_secondary', data });
    const handleCloseAll = () => dispatch({ type: 'close_all' });
    return (React.createElement(React.Fragment, null,
        cloneElement(trigger, {
            onClick: () => {
                if (trigger.props.onClick) {
                    trigger.props.onClick();
                }
                handleOpenMain();
            },
        }),
        React.createElement(Drawer, { isOpen: state.mainIsOpen, onClose: handleCloseAll },
            React.createElement("div", { className: styles.list }, items.map((item) => (item.items ? (React.createElement(DrawerListItem, { hasSecondary: true, key: item.title, onTouch: () => handleOpenSecondary(item.items) }, item.title)) : (React.createElement(DrawerListItem, { key: item.title, onTouch: () => {
                    if (item.onClick) {
                        item.onClick();
                    }
                    handleCloseAll();
                } }, item.title)))))),
        React.createElement(Drawer, { isOpen: state.secondaryIsOpen, onClose: handleCloseAll },
            React.createElement("div", { className: styles.list }, state.secondaryItems.map((item) => (React.createElement(DrawerListItem, { key: item.title, onTouch: () => {
                    if (item.onClick) {
                        item.onClick();
                    }
                    handleCloseAll();
                } }, item.title)))))));
};
export default DrawerList;
